import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/info_icon@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-044afb69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "left column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Troubleshooter", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "For phone and internet service", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Check for outages, test your service, and make a repair appointment. ", -1))
const _hoisted_6 = { class: "field-radiobutton-container" }
const _hoisted_7 = { class: "field-radiobutton" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rbSTSLanding1" }, "Account, phone number, or email", -1))
const _hoisted_9 = { class: "field-radiobutton" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rbSTSLanding2" }, "My CenturyLink profile", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "p-float-label NumberInputOrderOrRepairNumber_inputText" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "itNumberInputOrderOrRepairNumber1" }, "Account/Phone number/Email", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "NumberInputOrderOrRepairNumber_tooltip_img",
  alt: "Info"
}, null, -1))
const _hoisted_15 = {
  key: 0,
  id: "mobileTooltip",
  style: {"position":"inherit","opacity":"1.052","z-index":"1207","display":"inline-block"},
  class: "p-tooltip p-component p-tooltip-right TooltipCustom_tooltip_mobile TooltipCustom_tooltip_w_16"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-tooltip-arrow" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-tooltip-text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Please enter one of the following:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Account number"),
  /*#__PURE__*/_createTextVNode(" in the upper corner of your bill or online (9, 11, or 13 digits)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Phone Number - "),
  /*#__PURE__*/_createTextVNode("any 10-digit number we have on file with your account"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Email Address"),
  /*#__PURE__*/_createTextVNode(" we have on file with your account ")
], -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "p-error NumberInputAccountNumber_inputText NumberInputAccountNumber_strawberry"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "validation-error"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = {
  key: 4,
  class: "validation-error"
}
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { class: "p-float-label NumberInputOrderOrRepairNumber_inputText" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "itNumberInputOrderOrRepairNumber2" }, "Billing zip code", -1))
const _hoisted_28 = {
  key: 0,
  id: "mobileZipTooltip",
  style: {"display":"inline-block","position":"inherit","opacity":"1.06","z-index":"1182"},
  class: "p-tooltip p-component p-tooltip-right TooltipCustom_tooltip_mobile TooltipCustom_tooltip_w_16"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-tooltip-arrow" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-tooltip-text" }, " This is the zip code where your bill is mailed each month. If you do not receive a bill in the mail, the zip code appears on your CenturyLink monthly statement. ", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "p-error NumberInputAccountNumber_inputText NumberInputAccountNumber_strawberry"
}
const _hoisted_33 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "validation-error"
}
const _hoisted_36 = { class: "NumberInput_h_5" }
const _hoisted_37 = { class: "NumberInput_button_next_wrapper" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "NumberInput_h_5" }
const _hoisted_40 = { class: "NumberInput_button_next_wrapper" }
const _hoisted_41 = { class: "right column rightBlock" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cannot-find-account-title" }, " Can't find your account number? ", -1))
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    id: "tsFindAcctNum",
    class: "cannot-find-account-link",
    href: "https://www.centurylink.com/home/help/account/need-your-centurylink-account-number.html?_ga=2.260832650.647341681.1648053570-1580841985.1648053570",
    target: "_blank",
    rel: "noopener"
  }, " Find your account number on your bill ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PVRadioButton = _resolveComponent("PVRadioButton")!
  const _component_PVInputText = _resolveComponent("PVInputText")!
  const _component_TooltipCustom = _resolveComponent("TooltipCustom")!
  const _component_PVButton = _resolveComponent("PVButton")!
  const _component_SkeletonLoader = _resolveComponent("SkeletonLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_PVRadioButton, {
            id: "rbSTSLanding1",
            modelValue: _ctx.selectedIdentifier,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedIdentifier) = $event)),
            modelModifiers: { trim: true },
            name: "selectedIdentifier",
            value: "accountNumber"
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_PVRadioButton, {
            id: "rbSTSLanding2",
            modelValue: _ctx.selectedIdentifier,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIdentifier) = $event)),
            modelModifiers: { trim: true },
            name: "selectedIdentifier",
            value: "login"
          }, null, 8, ["modelValue"]),
          _hoisted_10
        ])
      ]),
      (_ctx.selectedIdentifier === 'accountNumber')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_PVInputText, {
                id: "itNumberInputOrderOrRepairNumber1",
                modelValue: _ctx.numberQuery,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.numberQuery) = $event)),
                modelModifiers: { trim: true },
                type: "username",
                disabled: _ctx.throttled,
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleStartSubmit(!_ctx.v$?.$invalid)), ["enter"]))
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_13,
              _createVNode(_component_TooltipCustom, {
                width: 16,
                value: "<strong>Please enter one of the following:</strong><br />\n            <strong>Account number</strong> in the upper corner of your bill or online (9, 11, or 13 digits)<br />\n            <strong>Phone Number -  </strong>any 10-digit number we have on file with your account<br />\n            <strong>Email Address</strong> we have on file with your account",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCustomTooltip()))
              }, {
                componentForTooltip: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              (_ctx.isVisibleOnMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            (_ctx.showValidateErrorsAccountNumber && _ctx.v$.$invalid)
              ? (_openBlock(), _createElementBlock("small", _hoisted_19, [
                  (
              _ctx.v$.numberQuery.isNotNoAcctsFoundErr.$invalid ||
              _ctx.v$.c360AcctList.isNotNoAcctsFoundErr.$invalid
            )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "No accounts found"))
                    : (
              _ctx.v$.numberQuery.isNotAcctDeactivatedErr.$invalid ||
              _ctx.v$.c360AcctList.isNotAcctDeactivatedErr.$invalid
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Account is deactivated"))
                      : (_ctx.v$.numberQuery.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Please enter your CenturyLink account number or phone number or email."))
                        : (_ctx.v$.numberQuery.isPhoneNumQueryRegexMatch.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Please enter a valid phone number."))
                          : (
              (_ctx.v$.numberQuery.isRegexMatch.$invalid &&
                !_ctx.v$.numberQuery.$model.includes('@')) ||
              _ctx.v$.numberQuery.isAcctNumQueryRegexMatch.$invalid
            )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Please enter a valid account number."))
                            : (
              (_ctx.v$.numberQuery.isRegexMatch.$invalid &&
                _ctx.v$.numberQuery.$model.includes('@')) ||
              _ctx.v$.numberQuery.isEmailQueryRegexMatch.$invalid
            )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Please enter a valid email."))
                              : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_PVInputText, {
                id: "itNumberInputOrderOrRepairNumber2",
                modelValue: _ctx.billingZip,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.billingZip) = $event)),
                modelModifiers: { trim: true },
                type: "username",
                disabled: _ctx.throttled,
                onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.handleStartSubmit(!_ctx.v$?.$invalid)), ["enter"]))
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_27,
              (_ctx.isVisibleZipOnMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                : _createCommentVNode("", true)
            ]),
            (_ctx.showValidateErrorsAccountNumber && _ctx.v$.$invalid)
              ? (_openBlock(), _createElementBlock("small", _hoisted_32, [
                  (_ctx.v$.billingZip.isZipCodeRegexMatch.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Please enter a valid zip code."))
                    : (
              _ctx.c360AcctList &&
              Object.values(_ctx.c360AcctList).length &&
              (_ctx.v$.billingZip.hasAcctsWithoutBadStatusesWithZip.$invalid ||
                _ctx.v$.c360AcctList.hasAcctsWithoutBadStatuses.$invalid)
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Records don't match"))
                      : (_ctx.v$.billingZip.required.$invalid)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Please enter a valid zip code."))
                        : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_SkeletonLoader, {
                  loading: _ctx.throttled || _ctx.pending,
                  "margin-auto": false
                }, {
                  componentToLoad: _withCtx(() => [
                    _createVNode(_component_PVButton, {
                      label: "Start",
                      disabled: _ctx.areInputsEmpty,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleStartSubmit(!_ctx.v$?.$invalid)))
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_PVButton, {
                  label: "Sign in",
                  onClick: _ctx.redirectToLogin
                }, null, 8, ["onClick"])
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_41, [
      _hoisted_42,
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          id: "tsGetAcctByEmail",
          class: "cannot-find-account-link loadInfoModalv2",
          href: `${_ctx.dhHostEnvVar}/login/retrieveAccountNumber`,
          target: "_blank",
          rel: "noopener"
        }, " Get your account number by email ", 8, _hoisted_43)
      ]),
      _hoisted_44
    ])
  ]))
}